import React from 'react';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const ParticipationGroupchart = (props) => {

    const labels = [];
    const Participated = [];
    const Registrated = [];

    props.Participation?.forEach(item => {
        if (item?.grade === props.SelectGrade) {
            for (let index = 0; index < props.Labels?.length; index++) {
                labels.push(`Section ${props.Labels[index]}`);
                Participated.push(item[`sec${props.Labels[index]}_Participated`]);
                Registrated.push(item[`sec${props.Labels[index]}_Registrated`]);
            }
        }
    });


    const data = {
        labels,
        datasets: [
            { label: 'Registered', data: Registrated,  backgroundColor: '#F7C66A', },
            { label: 'Attended', data: Participated, backgroundColor: '#7C60BC', },
        ],
    };

    const options = {
        aspectRatio: 1.8,
        responsive: true,
        plugins: {
          legend: { position: 'bottom', labels: { usePointStyle: true, }, },

            tooltip: {
                callbacks: {
                    label: function (context) {
                        let label = context.dataset.label || '';
                        if (label) { label += ': '; }
                        if (context.parsed.y !== null) { label += context.parsed.y; }
                        return label;
                    }
                }
            },
            datalabels: {
                anchor: "end",
                align: "end",
                offset: -5,
                formatter: (value) => {
                  return value;
                },
                font: {
                  size: 12,
                  weight: "bold",
                },
              },
        },
        scales: {
            x: { grid: { display: false, }, },
            y: { max: 100, title: { display: true, text: 'Number of students' }, }
        },
    };

    return <Bar options={options} data={data} plugins={[ChartDataLabels]} ref= {props.Ref} />;
};
export default ParticipationGroupchart;